import { FC } from "react";
import { Box, Skeleton, Stack, Typography } from "@mui/material";
import BookmarkIcon from "@mui/icons-material/Bookmark";

const AbsenceTypesListItemSkeleton: FC = () =>
  Array.from(new Array(3)).map((_item) => (
    <Stack direction="row" spacing={4} alignItems="center" mb="1.5rem">
      <BookmarkIcon sx={{ color: "text.disabled" }} />
      <Box flexBasis="50%">
        <Skeleton variant="text" width={150} />
        <Skeleton variant="text" width={600} />
        <Skeleton variant="text" width={600} />
      </Box>
    </Stack>
  ));

export default AbsenceTypesListItemSkeleton;
